<template>
  <div class="ibox-child">
    <div class="row">
      <div class="form-group col-sm-12 info-status">
        <div class="panel">
          <div class="public-body">
            <div class="">
              <label class="control-label status-label" for="status">{{$t('releaseLabelTitle')}}</label>
              <span v-if="checkedUsers.length == 0 && checkedGroups.length == 0 && checkedOrgs == 0">{{$t('allPeopleStrType')}}</span>
              <span v-else-if="checkedUsers.length>0">{{ $t('userBtnTile') }}</span>
              <span v-else-if="checkedGroups.length>0">{{ $t('peopleGroupTileType') }}</span>
              <span v-else-if="checkedOrgs.length>0">{{ $t('organizationLabelStr') }}</span>
            </div>
            <div class="panel-footer info-add">
              <!-- 公開範囲のリセット -->
              <span @click="emitPublic" class="btn btn-success add-public add-public"><i class="fa fa-plus"></i>{{$t('addStr')}}</span>
              <span @click="emitResetPublic" class="btn btn-primary add-public add-public">{{$t('popTitleStr12')}}</span>
            </div>
          </div>
          <div class="status-control">
            <div v-if="checkedUsers.length > 0" class="public-box">
              <ul>
                <!-- <li v-for="(user, key) in getCheckedUsersInfo" :key="user.id" v-if="user.userInfo.userName"> -->
                <li v-for="user in getCheckedUsersInfo" :key="user.id" v-if="user.userInfo.userName" class="public-cell">
                  <span class="public-userimg">
                    <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle" />
                    <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle" />
                  </span>
                  <div class="public-userinfo">
                    <span class="public-username">{{user.userInfo.userName}}</span>
                  </div>
                  <span @click="emitDeletePublicUser(user.userId)" class="reply-tag"><i class="fa fa-times cursor"></i></span>
                </li>
              </ul>
            </div>
          </div>
          <div class="status-control">
            <div class="">
              <label v-if="checkedUsers.length>0 && checkedGroups.length>0" class="control-label status-label" for="status">{{$t('releaseLabelTitle')}}</label>
              <span v-if="checkedGroups.length>0 && checkedUsers.length>0">{{$t('peopleGroupTileType')}}</span>
              <div class="status-control">
                <div v-if="checkedGroups.length > 0" class="public-box">
                  <ul>
                    <!-- <li v-for="(group, key) in getCheckedGroupsInfo" :key="group.id" v-if="group.groupName"> -->
                    <li v-for="group in getCheckedGroupsInfo" :key="group.id" v-if="group.groupName" class="public-cell">
                      <span class="public-username">{{group.groupName}}</span>
                      <span @click="emitDeletePublicGroup(group.id)" class="reply-tag"><i class="fa fa-times cursor"></i></span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="status-control">
            <div class="">
              <label v-if="(checkedUsers.length>0 || checkedGroups.length>0) && checkedOrgs.length>0" class="control-label status-label" for="status">{{$t('releaseLabelTitle')}}</label>
              <span v-if="(checkedUsers.length>0 || checkedGroups.length>0) && checkedOrgs.length>0">{{$t('organizationLabelStr')}}</span>
              <div class="status-control">
                <div v-if="checkedOrgs.length>0" class="public-box">
                  <ul>
                    <li v-for="(org, key) in getCheckedOrgsInfo" :key="org.id" v-if="org.groupName">
                    <li v-for="org in getCheckedOrgsInfo" :key="org.id" v-if="org.groupName" class="public-cell">
                      <span class="public-username">{{org.groupName}}</span>
                      <span @click="emitDeletePublicOrg(org.id)" class="reply-tag"><i class="fa fa-times cursor"></i></span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'RegistPublic',
  components: {
  },
  computed: {
    ...mapGetters('users/', [
      'getUsersByIds'
    ]),
    ...mapGetters('groups/', [
      'getGroupsByIds'
    ]),
    getCheckedUsersInfo: function () {
      return this.getUsersByIds(this.checkedUsers)
    },
    getCheckedGroupsInfo: function () {
      return this.getGroupsByIds(this.checkedGroups)
    },
    getCheckedOrgsInfo: function () {
      return this.getGroupsByIds(this.checkedOrgs)
    }
  },
  props: {
    checkedUsers: Array,
    checkedGroups: Array,
    checkedOrgs: Array
  },
  data: function () {
    return {
    }
  },
  methods: {
    emitPublic: function () {
      // console.log('child emit clear')
      this.$emit('open-public', 'public')
    },
    emitResetPublic: function () {
      this.$emit('reset-public')
    },
    emitDeletePublicUser: function (userId) {
      this.$emit('delete-public-user', userId)
    },
    emitDeletePublicGroup: function (groupId) {
      this.$emit('delete-public-group', groupId)
    },
    emitDeletePublicOrg: function (orgId) {
      this.$emit('delete-public-org', orgId)
    }
  },
  updated: function () {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Regist/RegistPublic.vue